import { FunctionComponent } from 'react'
import {
  Autocomplete,
  Modal,
  Text,
  Textarea,
  getTheme,
} from '@conexasaude/conexa-hero'
import usePaymentReverseModal from './PaymentReverseModal.hook'
import useStyles from './PaymentReverseModal.styles'

const PaymentReverseModal: FunctionComponent = () => {
  const styles = useStyles()
  const theme = getTheme()
  const {
    closeModal,
    modalOpen,
    reasonChargeback,
    serviceDetailsList,
    disabledButton,
    setDetails,
    handleReason,
    handlePaymentReverse,
    paymentReverseIsLoading,
  } = usePaymentReverseModal()

  return (
    <Modal
      title="Estornar pagamento"
      opened={Boolean(modalOpen)}
      primaryActionLabel="Estornar"
      primaryAction={handlePaymentReverse}
      busyPrimaryAction={paymentReverseIsLoading}
      disabledPrimaryAction={!disabledButton}
      negativeActionLabel="Cancelar"
      negativeAction={closeModal}
      onClose={closeModal}
      size={500}
    >
      <div css={styles.container}>
        <Text renderAs="span">Valor a ser estornado: </Text>
        <Text renderAs="span" color={theme.colors.brand.primary[300]}>
          {serviceDetailsList?.patientPayment?.amountPaid}
        </Text>
        <div>
          <Text renderAs="span">Cartão a ser estornado: </Text>
          <Text renderAs="span">
            Final {serviceDetailsList?.patientPayment?.endCard} -{' '}
            {serviceDetailsList?.patientPayment?.flagCard}
          </Text>
        </div>
      </div>
      <div css={styles.inputWrapper}>
        <Autocomplete
          label="Motivos*"
          optionLabel="value"
          placeholder="Selecione o motivo do estorno"
          options={reasonChargeback || []}
          onInputChange={(_, newValue) => {
            handleReason(newValue)
          }}
        />
      </div>
      <div css={styles.inputWrapper}>
        <Textarea
          label="Detalhes"
          fullWidth
          placeholder="Digite os detalhes do estorno"
          onChange={event => {
            setDetails(event.target.value)
          }}
        />
      </div>
    </Modal>
  )
}

export default PaymentReverseModal
